import React from 'react';
import { WHATSAPP_NUMBER_DISPLAY } from '@/lib/support';
import WhatsAppButton from '../WhatsAppButton';
import { WhatsAppLogo } from '../WhatsAppIcon';

/** Sidebar card inviting customers to file or track a claim over WhatsApp. */
const WhatsAppCard: React.FC = () => (
  <div className="tw-flex tw-w-full tw-flex-col tw-gap-2.5 tw-rounded-2xl tw-bg-ds-subtle tw-p-4">
    <div className="tw-flex tw-items-center tw-gap-2.5">
      <WhatsAppLogo />
      <p className="tw-text-[14px] tw-font-semibold tw-leading-[18px] tw-text-ds-text-primary">Quick claim on WhatsApp</p>
    </div>
    <p className="tw-text-[13px] tw-leading-[18px] tw-text-ds-text-secondary">
      File or track a claim by chat at {WHATSAPP_NUMBER_DISPLAY}
    </p>
    <WhatsAppButton showIcon={false} />
  </div>
);

export default WhatsAppCard;
